import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "components/ui/button";

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found | Fortify</title>
      </Helmet>
      <div className="flex flex-col items-center justify-center px-4 py-24 text-center min-h-[60vh]">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground mt-2">This page does not exist.</p>
        <Button className="mt-8" asChild>
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </>);

}